import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SplashScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-navigate after 2.5 seconds
    const timer = setTimeout(() => {
      const onboardingComplete = localStorage.getItem("onboarding_complete");
      if (onboardingComplete === "true") {
        navigate("/login");
      } else {
        navigate("/onboarding");
      }
    }, 2500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#1C3A7A] flex flex-col items-center justify-center">
      {/* Logo */}
      <div className="flex flex-col items-center">
        <img 
          src="/images/logo-icon.png" 
          alt="RecoveryMatch Logo" 
          className="w-40 h-auto object-contain mb-6"
        />
        
        {/* Brand Name */}
        <h1 className="text-3xl font-bold tracking-wide">
          <span className="text-white">Recovery</span>
          <span className="text-[#FAB710]">Match</span>
        </h1>
      </div>

      {/* Loading indicator */}
      <div className="absolute bottom-20">
        <div className="w-8 h-8 border-3 border-white border-t-transparent rounded-full animate-spin"></div>
      </div>
    </div>
  );
};

export default SplashScreen;
